import tw from "twin.macro";

//Intentar mantener la logica de los estilos centralizada, salvando algunas excepsiones.
export const SectionHeading = tw.h2`text-4xl pt-5 sm:text-4xl font-display font-bold text-center text-gray-800 leading-tight uppercase`
export const Subheading = tw.h5` text-black font-display text-primary-700`
